<template>
  <v-dialog v-model="showSubhireDialog" fullscreen>
    <v-card>
      <v-card-title class="secondary white--text px-4 py-2">
        <div v-if="!subHireID">
          <span v-if="!subHireID"> Sub Hire</span>
        </div>
        <div v-else>
          <span> Sub Hire {{ subHireNo }}</span>
        </div>

        <v-spacer></v-spacer>
        <v-btn icon @click="resetForm(), (showSubhireDialog = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text
        v-if="formErrors && formErrors.non_field_errors"
        class="mt-2"
      >
        <v-alert close-icon="mdi-close" dense type="error">
          <v-list
            class="pa-0"
            dense
            style="background: inherit !important"
            v-for="(error, i) in formErrors.non_field_errors"
            :key="i"
          >
            <v-list-item dense style="min-height: 20px !important">
              <span>{{ i + 1 }} .</span><span>{{ error }}</span>
            </v-list-item>
          </v-list>
        </v-alert>
      </v-card-text>

      <v-card-text class="pa-2">
        <v-form ref="subhireForm" v-if="value" v-model="isValid">
          <v-row class="ma-0">
            <v-col cols="12" lg="7">
              <v-row>
                <v-col cols="12" lg="auto">
                  <span class="text-caption">Route</span>
                  <p class="text-subtitle-1 font-weight-medium mb-0">
                    {{ daLaneTitle }}
                  </p>
                </v-col>
                <v-divider vertical class="mx-3"></v-divider>

                <v-col cols="12" lg="auto">
                  <span class="text-caption">Customer</span>
                  <p class="text-subtitle-1 font-weight-medium mb-0">
                    {{ daCustomer }}
                  </p>
                </v-col>
                <v-divider vertical class="mx-3"></v-divider>

                <v-col cols="12" lg="auto">
                  <span class="text-caption">Revenue</span>
                  <p class="text-subtitle-1 font-weight-medium mb-0">
                    {{ useStoredValues && !userChangedLegs ? (parseFloat(subHireFormDetails.da_rate || 0) * parseFloat(subHireFormDetails.total_legs_count || 0)).toFixed(2) : (useStoredValues ? subhireRate : daRate) }} {{ $globals.currency }}
                  </p>
                </v-col>
                <v-divider vertical class="mx-3"></v-divider>

                <v-col cols="12" lg="auto">
                  <span class="text-caption">Additional Charge</span>
                  <p class="text-subtitle-1 font-weight-medium mb-0">
                    {{ useStoredValues && !userChangedLegs ? (subHireFormDetails.customer_da_total_additional_charge || 0) : customerDaAdditionalCharge }} {{ $globals.currency }}
                  </p>
                </v-col>
                <v-divider vertical class="mx-3"></v-divider>

                <v-col cols="12" lg="auto">
                  <span class="text-caption">Total Revenue</span>
                  <p class="text-subtitle-1 font-weight-medium mb-0">
                    {{ useStoredValues && !userChangedLegs ? subHireFormDetails.total_revenue : totalRevenue }} {{ $globals.currency }}
                  </p>
                </v-col>
                <v-divider vertical class="mx-3"></v-divider>

                <v-col cols="12" lg="auto">
                  <span class="text-caption">Taxable Amount</span>
                  <p class="text-subtitle-1 font-weight-medium mb-0">
                    {{ useStoredValues && !userChangedLegs ? subHireFormDetails.total_revenue_tax_amount : daTotalTaxableAmount }} {{ $globals.currency }}
                  </p>
                </v-col>
                <v-divider vertical class="mx-3"></v-divider>

                <v-col cols="12" lg="auto">
                  <span class="text-caption">Total Revenue With Tax</span>
                  <p class="text-subtitle-1 font-weight-medium mb-0">
                    {{ useStoredValues && !userChangedLegs ? subHireFormDetails.total_revenue_with_tax : grandTotalProperty }} {{ $globals.currency }}
                  </p>
                </v-col>
                <v-divider vertical class="mx-3"></v-divider>

                <v-col cols="12" lg="auto">
                  <span class="text-caption">Sub Hire Leg Count</span>
                  <p class="text-subtitle-1 font-weight-medium mb-0">
                    {{ useStoredValues && !userChangedLegs ? subHireFormDetails.total_legs_count : totalDa }}
                  </p>
                </v-col>

                <v-col cols="12" lg="auto">
                  <span class="text-caption">DA Container Type</span>
                  <p class="text-subtitle-1 font-weight-medium mb-0">
                    {{ daContainerType }}
                  </p>
                </v-col>

                <v-col cols="12" class="px-0">
                  <v-divider></v-divider>
                </v-col>

                <v-row class="ma-0 d-flex align-center">
                  <v-col cols="12" lg="3" class="Form-Columns-Dense">
                    <v-switch
                      :readonly="
                        subHireFormDetails.bid_request != null ||
                        subHireFormDetails.lrfq_request != null
                      "
                      class="pa-0 ma-0"
                      :label="`From Bid : ${
                        jobDetails.is_bid == 'Yes' ? 'Yes' : 'No'
                      }`"
                      true-value="Yes"
                      false-value="No"
                      hide-details="auto"
                      v-model="jobDetails.is_bid"
                      :error-messages="formErrors.is_bid"
                      @change="
                        delete formErrors.is_bid;
                        getBidList();
                      "
                    ></v-switch>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="auto"
                    v-if="subHireFormDetails.bid_request != null"
                  >
                    <span class="text-caption">Bid Id</span>
                    <p class="text-subtitle-1 font-weight-medium mb-0">
                      {{ subHireFormDetails.bid_request_id }}
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="6"
                    class="Form-Columns-Dense"
                    v-if="jobDetails.is_bid == 'Yes'"
                  >
                    <MultiSelect
                      label="Select Bid *"
                      :items="bidList"
                      itemText="title"
                      itemValue="id"
                      :returnObject="true"
                      hide-details="auto"
                      :rules="[(val) => !!val || 'Bid is required']"
                      v-model="bidRequest"
                      :error-messages="formErrors.bidRequest"
                      @change="
                        delete formErrors.bidRequest;
                        setTransporterDetail();
                      "
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    lg="3"
                    class="Form-Columns-Dense"
                    v-if="jobDetails.is_bid == 'Yes'"
                  >
                    <v-btn
                      color="primary"
                      depressed
                      :disabled="
                        (subHireFormDetails &&
                          subHireFormDetails.status &&
                          subHireFormDetails.status == 'Invoice Updated') ||
                        subHireFormDetails.status == 'Completed' ||
                        bidList.length > 0 ||
                        (this.bidRequestDetail &&
                          this.bidRequestDetail.da_bid_exist)
                      "
                      @click="createBid"
                    >
                      Create Bid
                    </v-btn>
                  </v-col>
                </v-row>

                <v-col cols="12" class="px-0">
                  <v-divider></v-divider>
                </v-col>

                <v-row class="ma-0 d-flex align-center">
                  <v-col cols="12" lg="3" class="Form-Columns-Dense">
                    <v-switch
                      :readonly="subHireFormDetails.lrfq_request != null"
                      class="pa-0 ma-0"
                      :label="`From Lrfq : ${
                        lrfqDetails.is_lrfq == 'Yes' ? 'Yes' : 'No'
                      }`"
                      true-value="Yes"
                      false-value="No"
                      hide-details="auto"
                      v-model="lrfqDetails.is_lrfq"
                      :error-messages="formErrors.is_lrfq"
                      @change="
                        delete formErrors.is_lrfq;
                        getLrfqList();
                      "
                    ></v-switch>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="auto"
                    v-if="subHireFormDetails.lrfq_request != null"
                  >
                    <span class="text-caption">Lrfq Id</span>
                    <p class="text-subtitle-1 font-weight-medium mb-0">
                      {{ subHireFormDetails.lrfq_id }}
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="6"
                    class="Form-Columns-Dense"
                    v-if="lrfqDetails.is_lrfq == 'Yes'"
                  >
                    <MultiSelect
                      label="Select Lrfq *"
                      :items="lrfqList"
                      itemText="title"
                      itemValue="id"
                      :returnObject="true"
                      hide-details="auto"
                      :rules="[(val) => !!val || 'Lrfq is required']"
                      v-model="lrfqRequest"
                      :error-messages="formErrors.lrfqRequest"
                      @change="
                        delete formErrors.lrfqRequest;
                        setTransporterDetailFromLrfq();
                      "
                    />
                  </v-col>
                </v-row>

                <v-col cols="12" class="px-0">
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <MultiSelect
                    label="Select Transporter *"
                    :readonly="
                      (subHireFormDetails &&
                        subHireFormDetails.status &&
                        subHireFormDetails.status == 'Invoice Updated') ||
                      subHireFormDetails.status == 'Completed' ||
                      jobDetails.is_bid == 'Yes' ||
                      subHireFormDetails.bid_request != null
                    "
                    :items="transporterList"
                    itemText="company_title"
                    itemValue="id"
                    hide-details="auto"
                    :rules="[(val) => !!val || 'Transporter is required']"
                    v-model="subHireFormDetails.transporter"
                    :error-messages="formErrors.transporter"
                    @change="
                      delete formErrors.transporter;
                      checkVatApplicablity();
                    "
                  />
                </v-col>

                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <InputField
                    type="number"
                    :label="`Transport Charge (${$globals.currency}) *`"
                    hide-details="auto"
                    :clearable="false"
                    v-model="subHireFormDetails.rate"
                    :readonly="
                      (subHireFormDetails &&
                        subHireFormDetails.status &&
                        subHireFormDetails.status == 'Invoice Updated') ||
                      subHireFormDetails.status == 'Completed' ||
                      jobDetails.is_bid == 'Yes' ||
                      subHireFormDetails.bid_request != null
                    "
                    :rules="[(val) => !!val || 'Rate is required']"
                    :error-messages="formErrors.rate"
                    @input="
                      delete formErrors.rate;
                      setAdditionalChargeDetails();
                    "
                  />
                </v-col>

                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <InputField
                    type="number"
                    :clearable="false"
                    readonly
                    label="Tax(%) *"
                    class="grey lighten-3"
                    hide-details="auto"
                    :value="
                      Number(subHireFormDetails.tax_percentage || 0).toFixed(2)
                    "
                    :error-messages="formErrors.tax_percentage"
                    @input="
                      delete formErrors.tax_percentage;
                      setTotalTaxableAmount();
                    "
                  />
                </v-col>
                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <InputField
                    type="number"
                    readonly
                    :label="`Additional Charge (${$globals.currency})`"
                    class="grey lighten-3"
                    hide-details="auto"
                    :clearable="false"
                    v-model="transportTotalAdditionalCharge"
                  />
                </v-col>

                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <InputField
                    type="number"
                    readonly
                    :label="`Total Cost (${$globals.currency})`"
                    class="grey lighten-3"
                    hide-details="auto"
                    :clearable="false"
                    :value="subHireFormDetails.total_cost"
                  />
                </v-col>

                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <InputField
                    type="number"
                    :label="`Total Taxable Amount (${$globals.currency})`"
                    class="grey lighten-3"
                    :clearable="false"
                    readonly
                    hide-details="auto"
                    :value="subHireFormDetails.total_taxable_amount"
                  />
                </v-col>
                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <InputField
                    type="number"
                    :label="`Total Cost With Tax (${$globals.currency})`"
                    :clearable="false"
                    class="grey lighten-3"
                    readonly
                    hide-details="auto"
                    :value="subHireFormDetails.total_cost_with_tax"
                  />
                </v-col>
                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <InputField
                    type="number"
                    min="0"
                    readonly
                    :label="`Margin Rate (${$globals.currency})`"
                    class="grey lighten-3"
                    hide-details="auto"
                    :value="useStoredValues && !userChangedLegs ? subHireFormDetails.margin_amount : marginRate"
                    :clearable="false"
                  />
                </v-col>
                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <InputField
                    type="number"
                    min="0"
                    readonly
                    label="Margin Percentage*"
                    class="grey lighten-3"
                    :clearable="false"
                    hide-details="auto"
                    :value="useStoredValues && !userChangedLegs ? subHireFormDetails.margin_percentage : marginPercent"
                  />
                </v-col>

                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <InputField
                    type="text"
                    label="Reason For Sub Hire*"
                    :readonly="
                      (subHireFormDetails &&
                        subHireFormDetails.status &&
                        subHireFormDetails.status == 'Invoice Updated') ||
                      subHireFormDetails.status == 'Completed'
                    "
                    :rules="[(val) => !!val || 'Reason is required']"
                    hide-details="auto"
                    v-model="subHireFormDetails.reason_for_sub_hire"
                    :error-messages="formErrors.reason_for_sub_hire"
                    :clearable="false"
                    @input="delete formErrors.reason_for_sub_hire"
                  />
                </v-col>
                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <v-switch
                    class="mt-1"
                    hide-details="auto"
                    label="Cargo liability insurance"
                    :readonly="
                      (subHireFormDetails &&
                        subHireFormDetails.status &&
                        subHireFormDetails.status == 'Invoice Updated') ||
                      subHireFormDetails.status == 'Completed'
                    "
                    true-value="Yes"
                    false-value="No"
                    v-model="subHireFormDetails.cargo_liability_insurance"
                    :error-messages="formErrors.cargo_liability_insurance"
                    @change="delete formErrors.cargo_liability_insurance"
                  ></v-switch>
                </v-col>
                <v-col cols="12" lg="3" class="Form-Columns-Dense">
                  <v-switch
                    class="mt-1"
                    hide-details="auto"
                    label="General third party insurance"
                    :readonly="
                      (subHireFormDetails &&
                        subHireFormDetails.status &&
                        subHireFormDetails.status == 'Invoice Updated') ||
                      subHireFormDetails.status == 'Completed'
                    "
                    true-value="Yes"
                    false-value="No"
                    v-model="subHireFormDetails.general_third_party_insurance"
                    :error-messages="formErrors.general_third_party_insurance"
                    @change="delete formErrors.general_third_party_insurance"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" lg="5">
              <!-- Multi-search chips -->
              <div class="d-flex align-center flex-wrap mb-2" style="gap:6px">
                <!-- DA chip -->
                <v-chip
                  small
                  outlined
                  :color="activeChipKey === 'da_numbers' || chipValues.da_numbers ? 'primary' : 'default'"
                  :close="!!chipValues.da_numbers"
                  @click="toggleChip('da_numbers')"
                  @click:close="clearChip('da_numbers')"
                >
                  <v-icon small left>mdi-tag-outline</v-icon> DA no.
                </v-chip>

                <!-- Container chip -->
                <v-chip
                  small
                  outlined
                  :color="activeChipKey === 'container_numbers' || chipValues.container_numbers ? 'primary' : 'default'"
                  :close="!!chipValues.container_numbers"
                  @click="toggleChip('container_numbers')"
                  @click:close="clearChip('container_numbers')"
                >
                  <v-icon small left>mdi-tag-outline</v-icon> Container no.
                </v-chip>

                <!-- Sub hire chip -->
                <v-chip
                  small
                  outlined
                  :color="activeChipKey === 'sub_hire_ids' || chipValues.sub_hire_ids ? 'primary' : 'default'"
                  :close="!!chipValues.sub_hire_ids"
                  @click="toggleChip('sub_hire_ids')"
                  @click:close="clearChip('sub_hire_ids')"
                >
                  <v-icon small left>mdi-tag-outline</v-icon> Sub hire no.
                </v-chip>

                <!-- Inline input shown when a chip is active -->
                <template v-if="activeChipKey">
                  <v-text-field
                    v-model="chipInput"
                    dense
                    outlined
                    hide-details
                    :placeholder="'Enter ' + activeChipLabel.toLowerCase() + '....'"
                    style="min-width:260px"
                    @keyup.enter="applyChipFilter"
                    autofocus
                    append-icon="mdi-close"
                    @click:append="closeChipInput"
                  />
                </template>



                <v-chip v-if="!activeChipKey && totalDa > 0" x-small color="primary" outlined class="ml-2">
                  {{ totalDa }} selected
                </v-chip>
              </div>

              <AgGridVue
                style="width: 100%; height: 42vh"
                class="ag-theme-alpine"
                rowSelection="multiple"
                id="combineLegGrid"
                :columnDefs="headers"
                :context="context"
                @grid-ready="onGridReady"
                :defaultColDef="defaultColDef"
                :grid-options="gridOptions"
                @row-selected="onRowSelected"
              ></AgGridVue>
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="6" class="Form-Columns-Dense">
              <span class="text-h6 font-weight-regular"> Add Charge </span>
            </v-col>
            <v-col cols="6" class="Form-Columns-Dense text-right">
              <v-btn
                depressed
                small
                color="primary"
                @click="subHireFormDetails.sub_hire_job_charges.push({})"
                :disabled="
                  (subHireFormDetails &&
                    subHireFormDetails.status &&
                    subHireFormDetails.status == 'Invoice Updated') ||
                  subHireFormDetails.status == 'Completed'
                "
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" class="Form-Columns-Dense px-0">
              <v-divider></v-divider>
            </v-col>
          </v-row>

          <v-row
            v-for="(charge, i) in subHireFormDetails.sub_hire_job_charges"
            :key="i + keyUpdate"
            class="ma-0"
          >
            <v-col cols="1" class="Form-Columns-Dense">
              <span class="text-h6"> # {{ i + 1 }} </span>
            </v-col>
            <v-col cols="10">
              <v-row>
                <v-col cols="12" lg="4" class="Form-Columns-Dense">
                  <MultiSelect
                    label="Charge *"
                    :items="allCharges"
                    itemText="charge_title"
                    itemValue="id"
                    :rules="[(v) => !!v || 'Charge is Required']"
                    :returnObject="true"
                    hide-details="auto"
                    :readonly="
                      (subHireFormDetails &&
                        subHireFormDetails.is_used &&
                        subHireFormDetails.status) ||
                      subHireFormDetails.status == 'Invoice Updated' ||
                      subHireFormDetails.status == 'Completed'
                    "
                    v-model="charge.charge"
                    :error-messages="
                      formErrors &&
                      formErrors.sub_hire_job_charges &&
                      formErrors.sub_hire_job_charges[i] &&
                      formErrors.sub_hire_job_charges[i].charge
                        ? formErrors.sub_hire_job_charges[i].charge
                        : []
                    "
                    @input="
                      formErrors &&
                      formErrors.sub_hire_job_charges &&
                      formErrors.sub_hire_job_charges[i] &&
                      formErrors.sub_hire_job_charges[i].charge
                        ? delete formErrors.sub_hire_job_charges[i].charge
                        : null;
                      setChargeDetails($event, i);
                      checkChargeErrors();
                    "
                    @change="setAdditionalChargeDetails()"
                  />
                </v-col>
                <v-col cols="12" lg="4" class="Form-Columns-Dense">
                  <InputField
                    label="Description"
                    readonly
                    :clearable="false"
                    hide-details="auto"
                    v-model="charge.description"
                    :error-messages="
                      formErrors &&
                      formErrors.sub_hire_job_charges &&
                      formErrors.sub_hire_job_charges[i] &&
                      formErrors.sub_hire_job_charges[i].description
                        ? formErrors.sub_hire_job_charges[i].description
                        : []
                    "
                    @input="
                      formErrors &&
                      formErrors.sub_hire_job_charges &&
                      formErrors.sub_hire_job_charges[i] &&
                      formErrors.sub_hire_job_charges[i].description
                        ? delete formErrors.sub_hire_job_charges[i].description
                        : null;
                      checkChargeErrors();
                    "
                  />
                </v-col>
                <v-col cols="12" lg="1" class="Form-Columns-Dense">
                  <InputField
                    label="Cost GL No."
                    readonly
                    :clearable="false"
                    hide-details="auto"
                    v-model="charge.cost_gl_no"
                    :error-messages="
                      formErrors &&
                      formErrors.sub_hire_job_charges &&
                      formErrors.sub_hire_job_charges[i] &&
                      formErrors.sub_hire_job_charges[i].cost_gl_no
                        ? formErrors.sub_hire_job_charges[i].cost_gl_no
                        : []
                    "
                    @input="
                      formErrors &&
                      formErrors.sub_hire_job_charges &&
                      formErrors.sub_hire_job_charges[i] &&
                      formErrors.sub_hire_job_charges[i].cost_gl_no
                        ? delete formErrors.sub_hire_job_charges[i].cost_gl_no
                        : null;
                      checkChargeErrors();
                    "
                  />
                </v-col>
                <v-col cols="12" lg="1" class="Form-Columns-Dense">
                  <InputField
                    type="number"
                    label="TAX (%)"
                    readonly
                    :clearable="false"
                    hide-details="auto"
                    v-model="charge.tax_percentage"
                  />
                </v-col>
                <v-col cols="12" lg="2" class="Form-Columns-Dense">
                  <InputField
                    type="number"
                    :label="`Rate (${$globals.currency}) *`"
                    :disabled="!charge.charge"
                    :rules="[
                      (val) =>
                        val > 0 || 'Rate can not be less than or equal to 0',
                    ]"
                    hide-details="auto"
                    :readonly="
                      (subHireFormDetails &&
                        subHireFormDetails.is_used &&
                        subHireFormDetails.status) ||
                      subHireFormDetails.status == 'Invoice Updated' ||
                      subHireFormDetails.status == 'Completed'
                    "
                    v-model="charge.rate"
                    :error-messages="
                      formErrors &&
                      formErrors.sub_hire_job_charges &&
                      formErrors.sub_hire_job_charges[i] &&
                      formErrors.sub_hire_job_charges[i].rate
                        ? formErrors.sub_hire_job_charges[i].rate
                        : []
                    "
                    @input="
                      formErrors &&
                      formErrors.sub_hire_job_charges &&
                      formErrors.sub_hire_job_charges[i] &&
                      formErrors.sub_hire_job_charges[i].rate
                        ? delete formErrors.sub_hire_job_charges[i].rate
                        : null;
                      checkChargeErrors();
                      setAdditionalChargeDetails();
                    "
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              lg="1"
              class="Form-Columns-Dense align-self-center text-right"
            >
              <v-btn
                color="secondary"
                :disabled="
                  (subHireFormDetails &&
                    subHireFormDetails.status &&
                    subHireFormDetails.status == 'Invoice Updated') ||
                  subHireFormDetails.status == 'Completed'
                "
                small
                depressed
                @click="removeCharge(i)"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-text class="pa-2"></v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-end">
        <v-btn
          v-if="this.selectedLegs && this.selectedLegs.length > 0"
          color="primary"
          depressed
          :disabled="
            !isValid ||
            (subHireFormDetails &&
              subHireFormDetails.status &&
              subHireFormDetails.status == 'Invoice Updated') ||
            subHireFormDetails.status == 'Completed' ||
            subHireFormDetails.bid_request != null ||
            subHireFormDetails.lrfq_request != null
          "
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
      <CreateBidForm v-model="showBidForm" :bidFormDetails="bidDetails" />
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import FormComponent from "@/components/General/FormComponent.vue";
import { AgGridVue } from "ag-grid-vue";
import CreateBidForm from "@/components/ModuleBased/dialogForms/CreateBidForm.vue";

export default {
  components: {
    InputField,
    MultiSelect,
    AgGridVue,
    FormComponent,
    CreateBidForm,
  },

  props: {
    value: { type: Boolean, default: false },
    subHireID: { default: null },
    jobStatus: { type: String },
    legId: { default: null },
    legNumber: { default: null },
    daNumber: { default: null },
    subHireNumber: { default: null },
    laneId: { default: null },
    customerId: { default: null },
    daContractRate: { default: null },
    daRateTaxAmount: { default: null },
    daTotalRateWithTax: { default: null },
    daLaneCode: { default: null },
    daLaneType: { default: null },
    status: { default: null },
    containerType: { default: null },
  },

  data() {
    return {
      jobDetails: { is_bid: "No" },
      subHireSendStatus: null,
      daContainerType: null,
      bidDetails: {},
      lrfqDetails: { is_lrfq: "No" },
      bidRequestDetail: {},
      bidRequest: null,
      lrfqRequestDetail: {},
      lrfqRequest: null,
      getListCalled: false,
      showBidForm: false,
      today: new Date().toISOString().slice(0, 16),
      transporterList: [],
      bidList: [],
      lrfqList: [],
      selectedLegs: [],
      allCharges: [],
      formErrors: {},
      isValid: true,
      selectedLane: null,
      userChangedLegs: false,
      userClickedCell: false,
      isRestoringSelection: false,
      storedCostDetails: null,
      preSelectedLegs: [],
      currentSelectedLegIds: [],
      // Explicit ids the user actually unchecked (isRestoringSelection false
      // at the time) - the one signal the backend trusts for removal, so a
      // grid rebuild can never look like a bulk removal.
      removedLegIds: [],
      legSearch: "",
      legSearchTimer: null,
      activeChipKey: null,
      chipInput: "",
      chipValues: { da_numbers: "", container_numbers: "", sub_hire_ids: "" },
      chipAllSelected: false,
      selectedLegsDataMap: {},
      daLane: null,
      daCustomer: null,
      daRate: 0,
      newRate: 0,
      customerDaAdditionalCharge: 0,
      daTotalWithoutTax: 0,
      daTotalTaxableAmount: 0,
      grandTotal: 0,
      daTaxAmount: null,
      daTotalRate: null,
      legRow: null,
      daLaneTitle: null,
      keyUpdate: 0,
      daNo: null,
      subHireNo: null,
      legNo: null,
      totalDa: 0,
      subHireStatus: null,
      subHireInitailStatus: null,
      subhireRate: 0,
      transportTotalAdditionalCharge: 0,
      transportTotalAmount: 0,
      transportTotalTaxableAmount: 0,
      transportGrandTotal: 0,
      marginRate: 0,
      marginPercent: 0,
      subHireFormDetails: {
        cargo_liability_insurance: "No",
        general_third_party_insurance: "No",
        sub_hire_job_charges: [],
      },
      laneServiceType: null,
      vendorVatApply: "Yes",

      headers: [
        {
          headerName: "",
          field: "select",
          width: 50,
          minWidth: 50,
          maxWidth: 50,
          suppressSizeToFit: true,
          checkboxSelection: (params) => {
            return !!(params?.data?.sub_hire_legs_checkbox);
          },
        },
        {
          headerName: "Leg",
          field: "leg_id",
          minWidth: 150,
        },
        {
          headerName: "DA",
          field: "da_no",
          minWidth: 120,
          onCellClicked: (params) => {
            if (params?.data?.da_id) {
              this.$router.push({
                path: `/app/admin/delivery-advice/details/${params.data.da_id}`,
              });
            }
          },
          cellStyle: (params) => {
            if (params?.data?.sub_hire_legs_checkbox) {
              return { color: "#FFA500", cursor: "pointer" };
            }
            return { cursor: "pointer" };
          },
        },
      

        {
          headerName: "BOE",
          field: "boe",
          minWidth: 120,
        },
        {
          headerName: "Container No",
          field: "sub_hire_leg_containers",
          minWidth: 120,
        },
        {
          headerName: "Sub Hire No.",
          field: "sub_hire_no",
          minWidth: 120,
        },

        {
          headerName: "Rate (AED)",
          field: "leg_rate",
          minWidth: 120,
        },
        {
          headerName: "Sub Hire Status",
          field: "sub_hire_status",
          minWidth: 100,
        },
        { headerName: "Bidding Id", field: "bidding_id", minWidth: 100 },
      ],

      legObject: {},
      defaultColDef: { resizable: true, flex: 1 },
      gridOptions: {
        rowModelType: "infinite",
        cacheBlockSize: 20,
        maxBlocksInCache: 10,
        onGridSizeChanged: () => {
          this.resizeGrid();
        },
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },
    };
  },

  watch: {
    value(val) {
      if (val) {
        this.jobDetails.is_bid = "No";
        this.lrfqDetails.is_lrfq = "No";
        this.bidList = [];
        this.lrfqList = [];

        if (this.containerType) {
          this.daContainerType = this.containerType.types;
        }

        this.subHireStatus = this.status;
        this.subHireInitailStatus = this.jobStatus;
        this.subHireSendStatus = this.jobStatus;

        this.getCharges();

        this.getTransporterList(() => {
          if (this.subHireFormDetails.transporter) {
            this.checkVatApplicablity();
          }
        });

        this.daLane = this.laneId;
        this.legRow = this.legId;
        this.legNo = this.legNumber;
        this.daNo = this.daNumber;
        this.legSearch = "";
        this.$nextTick(() => this.getLegListFromLane());

        if (this.subHireID) {
          this.subHireNo = this.subHireNumber;
          this.getSubHireObject(this.subHireID);
          if (this.subHireInitailStatus === "Created") {
            this.getLegListObject(this.legId);
            this.daCustomer = this.customerId;
          }
        } else {
          this.getLegListObject(this.legId);
          this.daCustomer = this.customerId;
        }
      } else {
        this.legRow = null;
        this.resetForm();
      }
    },
  },

  computed: {
    hasActiveChipSearch() {
      return Object.values(this.chipValues).some((v) => !!v);
    },
    activeChipLabel() {
      const labels = { da_numbers: "DA no", container_numbers: "Container no", sub_hire_ids: "Sub hire no" };
      return labels[this.activeChipKey] || "";
    },
    showSubhireDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    context() {
      return { parentComponent: this };
    },
    useStoredValues() {
      // Use stored DB fields whenever in edit mode (subHireID is set)
      // getSubHireObject is now called for all statuses including Created
      return !!this.subHireID;
    },
    totalRevenue() {
      if (this.subHireID) {
        this.Subhirerate = this.subHireFormDetails.da_rate;
        return (
          parseFloat(this.Subhirerate * this.totalDa) +
          parseFloat(this.customerDaAdditionalCharge)
        ).toFixed(2);
      } else {
        return (
          parseFloat(this.daRate) + parseFloat(this.customerDaAdditionalCharge)
        ).toFixed(2);
      }
    },
    grandTotalProperty() {
      return (
        parseFloat(this.totalRevenue) + parseFloat(this.daTotalTaxableAmount)
      ).toFixed(2);
    },
  },

  methods: {
    createBid() {
      this.showBidForm = true;
    },

    getLegListObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.trip
        .getNewLegDataforSubHire(id)
        .then((res) => {
          this.legObject = res.data;
          this.daRate = this.legObject.leg_rate;
          this.customerDaAdditionalCharge =
            this.legObject.customer_da_total_additional_charge;
          this.daTotalWithoutTax =
            parseFloat(this.daRate) +
            parseFloat(this.customerDaAdditionalCharge);
          this.daTotalTaxableAmount =
            this.legObject.customer_da_total_taxable_amount;
          this.grandTotal =
            parseFloat(this.daTotalWithoutTax) +
            parseFloat(this.daTotalTaxableAmount);
          this.daLaneTitle = this.legObject.leg_lane_title;
          this.laneServiceType = this.legObject.lane_service_type;
          this.daLane = this.legObject.laneId;

          if (this.laneServiceType == "local") {
            this.subHireFormDetails.tax_percentage = 5.0;
          } else if (this.laneServiceType == "Cross Border") {
            this.subHireFormDetails.tax_percentage = 0.0;
          }

          if (this.legObject.leg_container_details) {
            this.daContainerType =
              this.legObject.leg_container_details.types.join(", ");
          }
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    getSubHireObject(id) {
      this.isRestoringSelection = true;
      this.$bus.$emit("showLoader", true);
      let params = { id: id, leg_id: this.legRow };
      this.$api.subHire
        .getSubHireObject(params)
        .then((res) => {
          this.subHireFormDetails = res.data;
          this.subhireRate = res?.data?.da_rate;
          this.subHireStatus = this.subHireFormDetails.status;
          this.subHireSendStatus = res?.data?.status;
          this.daLaneTitle = res.data.leg_lane_title;
          this.daCustomer = res.data.customer;
          this.totalDa = this.subHireFormDetails.total_legs_count;
          this.daTotalWithoutTax =
            parseFloat(this.subhireRate) +
            parseFloat(this.customerDaAdditionalCharge);
          this.grandTotal =
            parseFloat(this.daTotalWithoutTax) +
            parseFloat(this.daTotalTaxableAmount);
          this.subHireNo = res.data.sub_hire_id;
          this.daNo = res.data.da_number;
          this.laneServiceType = res.data.da_lane_service_type;

          // For Created status: also load leg data for revenue display
          if (this.subHireFormDetails.status === "Created") {
            this.getLegListObject(this.legRow);
          }

          this.checkVatApplicablity();

          this.storedCostDetails = {
            total_cost: res.data.total_cost,
            total_taxable_amount: res.data.total_taxable_amount,
            total_cost_with_tax: res.data.total_cost_with_tax,
            margin_amount: res.data.margin_amount,
            margin_percentage: res.data.margin_percentage,
          };

          this.setAdditionalChargeDetails();
          this.calculateTotals();

          this.preSelectedLegs = this.subHireFormDetails?.selected_legs || [];
          this.currentSelectedLegIds = [...this.preSelectedLegs];
          this.setGridDatasource(this.preSelectedLegs);
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          console.error(err);
        });
    },

    getTransporterList(callback = null) {
      this.$bus.$emit("showLoader", true);
      const params = {
        company_type: "Transporter",
        limit: "all",
        is_active: true,
      };
      this.$api.company
        .getCompanySelectList(params)
        .then((res) => {
          this.transporterList = res.data;
          this.$bus.$emit("showLoader", false);
          if (callback && typeof callback === "function") {
            callback();
          }
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    checkVatApplicablity() {
      if (!this.transporterList || this.transporterList.length === 0) return;
      if (!this.subHireFormDetails.transporter) return;

      const selectedTransporter = this.transporterList.find(
        (t) => t.id == this.subHireFormDetails.transporter,
      );

      if (!selectedTransporter) return;

      this.vendorVatApply = selectedTransporter.vat_applicability;

      if (this.vendorVatApply == "No") {
        this.subHireFormDetails.tax_percentage = 0.0;
      } else {
        if (this.laneServiceType == "local") {
          this.subHireFormDetails.tax_percentage = 5.0;
        } else if (this.laneServiceType == "Cross Border") {
          this.subHireFormDetails.tax_percentage = 0.0;
        }
      }

      this.setAdditionalChargeDetails();
    },

    setTransporterDetail() {
      this.subHireFormDetails.transporter = this.bidRequest.transporter;
      this.subHireFormDetails.rate = this.bidRequest.rate;
      this.checkVatApplicablity();
      this.setAdditionalChargeDetails();
    },

    setTransporterDetailFromLrfq() {
      this.subHireFormDetails.transporter = this.lrfqRequest.transporter;
      this.subHireFormDetails.rate = this.lrfqRequest.rate;
      this.checkVatApplicablity();
      this.setAdditionalChargeDetails();
    },

    resetForm() {
      this.selectedLegs = [];
      this.totalDa = 0;
      this.userChangedLegs = false;
      this.userClickedCell = false;
      this.isRestoringSelection = false;
      this.storedCostDetails = null;
      this.preSelectedLegs = [];
      this.currentSelectedLegIds = [];
      this.removedLegIds = [];
      this.legSearch = "";
      this.activeChipKey = null;
      this.chipInput = "";
      this.chipValues = { da_numbers: "", container_numbers: "", sub_hire_ids: "" };
      this.chipAllSelected = false;
      this.selectedLegsDataMap = {};
      this.selectedLane = null;
      this.selectedRows = null;
      this.transportTotalAdditionalCharge = 0;
      this.transportTotalAmount = 0;
      this.marginPercent = 0;
      this.marginRate = 0;
      this.transportGrandTotal = 0;
      this.total_taxable_amount = 0;
      this.subHireFormDetails = {
        cargo_liability_insurance: "No",
        general_third_party_insurance: "No",
        sub_hire_job_charges: [],
      };
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.resizeGrid();
      if (this.preSelectedLegs?.length) {
        // edit mode: datasource already set by getSubHireObject with full selected legs
        this.setGridDatasource(this.preSelectedLegs);
      } else if (this.legRow) {
        // new mode or no pre-selected legs
        this.getLegListFromLane();
      }
    },

    resizeGrid() {
      if (this.gridOptions && "api" in this.gridOptions) {
        setTimeout(() => {
          this.gridOptions.api.sizeColumnsToFit();
        }, 100);
      }
    },

    calculateTotals() {
      if (this.subHireID) {
        let a = (
          parseFloat(this.subHireFormDetails.da_rate) * this.totalDa
        ).toFixed(2);
        this.subhireRate = a;
        this.legObject.customer_da_total_additional_charge =
          this.subHireFormDetails.customer_da_total_additional_charge;
        this.legObject.customer_da_total_taxable_amount =
          this.subHireFormDetails.customer_da_total_taxable_amount;
      }

      this.daRate = (
        parseFloat(this.legObject.leg_rate) * this.totalDa
      ).toFixed(2);

      if (this.totalDa > 0) {
        let selectDaAdditionalCharge = 0;
        let selectDaTotalTaxableAmount = 0;
        this.selectedLegs.forEach((charge) => {
          selectDaAdditionalCharge += parseFloat(
            charge.customer_da_total_additional_charge,
          );
          selectDaTotalTaxableAmount += parseFloat(
            charge.customer_da_total_taxable_amount,
          );
        });
        this.customerDaAdditionalCharge = Number(
          selectDaAdditionalCharge,
        ).toFixed(2);
        this.daTotalTaxableAmount = Number(selectDaTotalTaxableAmount).toFixed(
          2,
        );
      } else {
        this.customerDaAdditionalCharge = 0;
        this.daTotalTaxableAmount = 0;
      }

      this.setAdditionalChargeDetails();
      this.setTotalTaxableAmount();
    },

    onRowSelected(event) {
      if (this.isRestoringSelection || !event.data) return;

      this.userChangedLegs = true;
      const legId = event.data.id;

      if (event.node.isSelected()) {
        if (!this.currentSelectedLegIds.includes(legId)) {
          this.currentSelectedLegIds.push(legId);
        }
        // Store full row data so it can be recovered after datasource switch
        this.selectedLegsDataMap[legId] = event.data;
      } else {
        const index = this.currentSelectedLegIds.indexOf(legId);
        if (index > -1) {
          this.currentSelectedLegIds.splice(index, 1);
        }
        delete this.selectedLegsDataMap[legId];
        // Only reached when isRestoringSelection is false, i.e. this is a
        // real click, not a grid-rebuild side effect - safe to record as an
        // explicit removal.
        if (this.preSelectedLegs.includes(legId) && !this.removedLegIds.includes(legId)) {
          this.removedLegIds.push(legId);
        }
      }

      this.totalDa = this.currentSelectedLegIds.length;
      // selectedLegs uses the data map so it includes ALL selected rows, not just visible ones
      this.selectedLegs = this.currentSelectedLegIds
        .map((id) => this.selectedLegsDataMap[id])
        .filter(Boolean);
      this.calculateTotals();
    },


    setSelectedValues(selectedLegs = []) {
      if (!this.gridApi) return;
      this.isRestoringSelection = true;
      this.gridApi.forEachNode((node) => {
        if (node.data && selectedLegs.indexOf(node.data.id) > -1) {
          node.setSelected(true);
        }
      });
      this.isRestoringSelection = false;
    },

    // Every gridApi.setDatasource(...) call destroys and rebuilds the grid's
    // row nodes, which fires deselection events for whatever was selected
    // before - onRowSelected can't tell that apart from a real user uncheck.
    // Route every rebuild through here so isRestoringSelection is up for the
    // whole rebuild (not just the brief re-check step), so those synthetic
    // deselections are ignored and only an explicit click removes a leg.
    setGridDatasource(preSelectIds = []) {
      if (!this.gridApi) return;
      this.isRestoringSelection = true;
      this.gridApi.setDatasource(this.buildDatasource(preSelectIds));
      if (!preSelectIds.length) {
        this.$nextTick(() => {
          this.isRestoringSelection = false;
        });
      }
    },

    buildDatasource(preSelectIds = []) {
      const vm = this;
      return {
        getRows(params) {
          const limit = params.endRow - params.startRow;
          const offset = params.startRow;
          if (offset > 0) vm.$bus.$emit("showLoader", true);
          vm.$api.subHire
            .getLegListFromLane(vm.legRow, {
              limit,
              offset,
              search: vm.legSearch || undefined,
            })
            .then((res) => {
              const rows = res.data;
              const total = res.count != null ? res.count : rows.length;
              params.successCallback(rows, total);
              if (preSelectIds.length) {
                vm.$nextTick(() => vm.setSelectedValues(preSelectIds));
              }
            })
            .catch((err) => {
              console.error(err);
              vm.isRestoringSelection = false;
              params.failCallback();
            })
            .finally(() => {
              if (offset > 0) vm.$bus.$emit("showLoader", false);
            });
        },
      };
    },

    getLegListFromLane() {
      this.setGridDatasource([this.legRow]);
    },

    onLegSearchInput() {
      clearTimeout(this.legSearchTimer);
      this.legSearchTimer = setTimeout(() => {
        // Preselect from the authoritative ID list, not an empty array -
        // setDatasource rebuilds the grid's row nodes from scratch, so any
        // selected leg not passed here gets silently dropped.
        this.setGridDatasource([...this.currentSelectedLegIds]);
      }, 400);
    },

    onLegSearchClear() {
      this.legSearch = "";
      this.setGridDatasource([...this.currentSelectedLegIds]);
    },

    toggleChip(key) {
      if (this.activeChipKey === key) {
        this.activeChipKey = null;
        this.chipInput = "";
      } else {
        this.activeChipKey = key;
        this.chipInput = this.chipValues[key] || "";
      }
    },

    applyChipFilter() {
      if (!this.chipInput.trim() || !this.activeChipKey) return;
      // Normalize: replace newlines, tabs, multiple spaces with commas so Excel paste works
      const normalized = this.chipInput
        .trim()
        .replace(/[\r\n\t]+/g, ',')
        .replace(/\s*,\s*/g, ',')
        .replace(/\s+/g, ',')
        .replace(/,+/g, ',')
        .replace(/^,|,$/g, '');
      this.chipInput = normalized;
      this.chipValues[this.activeChipKey] = normalized;
      // Keep activeChipKey and chipInput so the input box stays visible after search
      this.applyChipSearch();
    },

    closeChipInput() {
      const key = this.activeChipKey;
      this.chipValues[key] = "";
      this.activeChipKey = null;
      this.chipInput = "";
      if (this.hasActiveChipSearch) {
        this.applyChipSearch();
      } else {
        this.setGridDatasource([...this.currentSelectedLegIds]);
      }
    },

    clearChip(key) {
      this.chipValues[key] = "";
      this.activeChipKey = null;
      this.chipInput = "";
      if (this.hasActiveChipSearch) {
        this.applyChipSearch();
      } else {
        this.clearAllSearchChips();
      }
    },

    clearAllSearchChips() {
      this.chipValues = { da_numbers: "", container_numbers: "", sub_hire_ids: "" };
      this.activeChipKey = null;
      this.chipInput = "";
      this.chipAllSelected = false;
      // Use authoritative ID list — not gridApi.getSelectedRows() which only returns visible rows
      this.setGridDatasource([...this.currentSelectedLegIds]);
    },

    chipSelectAll() {
      if (this.chipAllSelected) {
        this.gridApi.deselectAll();
        this.chipAllSelected = false;
      } else {
        this.gridApi.forEachNode((node) => {
          if (node.data && node.data.sub_hire_legs_checkbox) {
            node.setSelected(true);
          }
        });
        this.chipAllSelected = true;
      }
    },

    onHeaderCheckboxChange(checked) {
      if (checked) {
        this.gridApi.forEachNode((node) => {
          if (node.data && node.data.sub_hire_legs_checkbox) {
            node.setSelected(true);
          }
        });
      } else {
        this.gridApi.deselectAll();
      }
    },

    applyChipSearch() {
      this.chipAllSelected = false;
      const params = { leg_id: this.legRow };
      Object.entries(this.chipValues).forEach(([k, v]) => { if (v) params[k] = v; });

      // Snapshot current selections from the authoritative ID list + data map
      const selectedIdSet = new Set(this.currentSelectedLegIds);

      this.$bus.$emit("showLoader", true);
      this.$api.subHire
        .getLegs(params)
        .then((res) => {
          const searchRows = res.data || [];

          if (this.gridApi) {
            // Guard set here, before the rebuild - setDatasource's own
            // teardown of the old row nodes fires deselection events that
            // must not be mistaken for the user unchecking those legs.
            this.isRestoringSelection = true;
            this.gridApi.setDatasource({
              rowCount: searchRows.length,
              getRows: (p) => {
                const slice = searchRows.slice(p.startRow, p.endRow);
                p.successCallback(slice, searchRows.length);
                // Re-check selected rows silently (guard prevents recalculation)
                this.$nextTick(() => {
                  this.isRestoringSelection = true;
                  this.gridApi.forEachNode((node) => {
                    if (node.data && selectedIdSet.has(node.data.id)) {
                      node.setSelected(true);
                    }
                  });
                  this.isRestoringSelection = false;
                });
              },
            });
          }
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    getBidList(params = {}) {
      if (this.jobDetails.is_bid === "Yes") {
        this.bidRequest = null;
        this.$bus.$emit("showLoader", true);
        params.leg_id = this.legRow;
        this.$api.bidding
          .getBidListForSubHire(params)
          .then((res) => {
            this.bidRequestDetail = res.data;
            this.bidList = res.data.bid_list;
            this.bidDetails.lane = res.data.lane_id;
            this.bidDetails.container_type_count = res.data.da_container_type;
            this.bidDetails.job_type = res.data.job_type;
            this.bidDetails.lane_title = res.data.da_lane_title;
            this.bidDetails.container_type = this.daContainerType;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.$bus.$emit("showLoader", false);
          });
      } else {
        this.subHireFormDetails.transporter = null;
        this.subHireFormDetails.rate = null;
      }
    },

    getLrfqList(params = {}) {
      if (this.lrfqDetails.is_lrfq === "Yes") {
        this.lrfqRequest = null;
        this.$bus.$emit("showLoader", true);
        params.leg_id = this.legRow;
        this.$api.lrfq
          .getLrfqListForSubHire(params)
          .then((res) => {
            this.lrfqRequestDetail = res.data;
            this.lrfqList = res.data.lrfq_list;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.$bus.$emit("showLoader", false);
          });
      } else {
        this.subHireFormDetails.transporter = null;
        this.subHireFormDetails.rate = null;
      }
    },

    setChargeDetails(val, index) {
      if (val) {
        this.subHireFormDetails.sub_hire_job_charges[index].charge = val.id;
        this.subHireFormDetails.sub_hire_job_charges[index].charge_title =
          val.charge_title;
        this.subHireFormDetails.sub_hire_job_charges[index].cost_gl_no =
          val.cost_gl_no;
        this.subHireFormDetails.sub_hire_job_charges[index].description =
          val.description;
        this.subHireFormDetails.sub_hire_job_charges[index].rate = val.rate;
        this.subHireFormDetails.sub_hire_job_charges[index].tax_percentage =
          val.tax_percentage;
        this.keyUpdate++;
      } else if (this.subHireFormDetails?.sub_hire_job_charges) {
        this.subHireFormDetails.sub_hire_job_charges[index] = {};
      }
    },

    setAdditionalChargeDetails() {
      this.transportTotalAdditionalCharge = 0.0;
      this.subHireFormDetails.sub_hire_job_charges.forEach((charge) => {
        if (charge.rate) {
          this.transportTotalAdditionalCharge += parseFloat(
            parseFloat(charge.rate).toFixed(2),
          );
        }
      });

      this.subHireFormDetails.total_cost = (
        (parseFloat(this.subHireFormDetails.rate) +
          parseFloat(this.transportTotalAdditionalCharge)) *
        parseFloat(this.totalDa)
      ).toFixed(2);

      this.marginRate = (
        parseFloat(this.totalRevenue) -
        parseFloat(this.subHireFormDetails.total_cost)
      ).toFixed(2);

      this.marginPercent = (
        (this.marginRate / parseFloat(this.totalRevenue)) *
        100
      ).toFixed(2);

      this.setTotalTaxableAmount();
    },

    setTotalTaxableAmount() {
      this.subHireFormDetails.total_taxable_amount = 0.0;
      this.subHireFormDetails.sub_hire_job_charges.forEach((charge) => {
        if (charge.rate) {
          this.subHireFormDetails.total_taxable_amount +=
            (parseFloat(charge.rate) * parseFloat(charge.tax_percentage)) / 100;
        }
      });
      if (this.subHireFormDetails.rate) {
        this.subHireFormDetails.total_taxable_amount +=
          (parseFloat(this.subHireFormDetails.rate) *
            parseFloat(this.subHireFormDetails.tax_percentage)) /
          100;
        this.subHireFormDetails.total_taxable_amount = (
          this.subHireFormDetails.total_taxable_amount *
          parseFloat(this.totalDa)
        ).toFixed(2);
      }
      this.subHireFormDetails.total_cost_with_tax = (
        parseFloat(this.subHireFormDetails.total_cost) +
        parseFloat(this.subHireFormDetails.total_taxable_amount)
      ).toFixed(2);
    },

    getCharges() {
      this.$bus.$emit("showLoader", true);
      this.$api.charge
        .getChargeList({ limit: "all", is_active: "true" })
        .then((res) => {
          this.allCharges = res.data;
          this.$bus.$emit("showLoader", false);
        })
        .catch(() => {
          this.$bus.$emit("showLoader", false);
        });
    },

    addCharge() {
      this.subHireFormDetails.sub_hire_job_charges.push({});
    },

    removeCharge(i) {
      this.subHireFormDetails.sub_hire_job_charges.splice(i, 1);
      this.setAdditionalChargeDetails();
    },

    checkChargeErrors() {
      if (
        this.formErrors?.sub_hire_job_charges &&
        (this.formErrors.sub_hire_job_charges.length === 0 ||
          this.formErrors.sub_hire_job_charges.every(
            (obj) => Object.keys(obj).length === 0,
          ))
      ) {
        delete this.formErrors.sub_hire_job_charges;
      }
    },

    submitForm(data = {}) {
      this.formErrors = {};
      this.$bus.$emit("showLoader", true);
      let bidRequesId = this.bidRequest ? this.bidRequest.id : null;
      let lrfqRequestId = this.lrfqRequest ? this.lrfqRequest.id : null;

      data = {
        current_leg: this.legId,
        ...this.subHireFormDetails,
        selected_legs: this.currentSelectedLegIds,
        // Explicit unchecks only - see onRowSelected. The backend removes
        // exactly these ids and leaves anything else alone.
        removed_leg_ids: this.removedLegIds,
        bid_request: bidRequesId,
        lrfq_request: lrfqRequestId,
      };

      if (!this.subHireID) {
        this.$api.subHire
          .submitSubhireData(data)
          .then(() => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Success",
              color: "success",
            });
            this.resetForm();
            this.showSubhireDialog = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't Assigned Sub hire on leg(s)!",
              color: "error",
            });
            if (err.data) this.formErrors = err.data;
          });
      } else {
        data = { id: this.subHireID, data: { ...data } };
        if (this.subHireSendStatus == "Created") {
          data.data.status = "Pending";
        }
        this.$api.subHire
          .updateSubHireJob(data)
          .then(() => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Success",
              color: "success",
            });
            this.resetForm();
            this.showSubhireDialog = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't Assigned Sub hire on leg(s)!",
              color: "error",
            });
            if (err.data) this.formErrors = err.data;
          });
      }
    },
  },
};
</script>
